import { useState } from 'react'
import { trackUserEvent } from '@vend/utilities'
import { FEATURE_SHOW_SPECIAL_ORDERS_IN_INVENTORY } from '../../../../constants'
import { WEB_REGISTER } from '../../../web-register.constant'
import { focusGlobalSearch } from '../../../../ng-compat/hooks'
import { getFeatureFromCache } from '../../../../util/feature-cache'

export interface LineItemProductDetailsButtonProps {
  productId: string
}

interface InventoryConfig {
  specialOrderColumn?: {
    position: 'early' | 'late'
    showBorder?: boolean
  }
}

export const useLineItemProductDetailsButtonModel = (
  props: LineItemProductDetailsButtonProps
) => {
  const showSpecialOrderColumn = getFeatureFromCache(
    FEATURE_SHOW_SPECIAL_ORDERS_IN_INVENTORY
  )
  const inventoryConfig: InventoryConfig = showSpecialOrderColumn
    ? { specialOrderColumn: { position: 'early', showBorder: false } }
    : {}

  const [isProductModalOpen, setProductModalOpen] = useState(false)
  const openProductModal = () => {
    trackUserEvent(
      WEB_REGISTER.DISPLAY_NAME,
      'Show Product Information',
      { view: 'Line Item' },
      { useSendBeacon: true }
    )
    setProductModalOpen(true)
  }

  const closeProductModal = () => {
    setProductModalOpen(false)
    focusGlobalSearch()
  }

  return {
    isProductModalOpen,
    inventoryConfig,
    openProductModal,
    closeProductModal,
  }
}
